import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { sdkTouchOptimizedStyles } from "scmp-sdk/components/follow-button/styles";

export const DottySpan = styled.span`
  ::after {
    content: "";

    display: inline-block;

    animation: dotty steps(1, end) 2s infinite;
  }

  @keyframes dotty {
    0% {
      content: "";
    }
    25% {
      content: ".";
    }
    50% {
      content: "..";
    }
    75% {
      content: "...";
    }
    100% {
      content: "";
    }
  }
`;

type SubmitButtonProps = {
  $buttonSize: string;
};

export const SubmitButton = styled.button<SubmitButtonProps>`
  block-size: 35px;
  min-inline-size: 86px;

  color: #ffffff;
  font-size: 14px;
  line-height: 16px;

  border: 0;
  border-radius: 2px;

  background-color: #4585ff;

  cursor: pointer;

  ${props => {
    switch (props.$buttonSize) {
      case "large":
        return css`
          min-inline-size: 244px;
        `;
      case "small":
        return css`
          min-inline-size: 82px;
        `;
    }
  }}

  ${sdkTouchOptimizedStyles}
`;
